const API_ENDPOINTS = {
  USER: {
    USAGE_STATS: '/user/usage-stats',
    PREFERENCES: '/user/preferences',
    UPDATE_PROFILE: '/user/profile',
  },
  SUBSCRIPTION: {
    CANCEL: '/subscription/cancel',
    HISTORY: '/subscription/history',
    CUSTOMER_PORTAL: '/subscription/customer-portal',
  },
};

export default API_ENDPOINTS;
